import store from '@/store'
import { getAllDp } from '@/api/department'
import { traverseDpTree } from '@/utils/util'
import { detail as getQuarterDetail } from '@/api/quarter'
import { regionList as getRegionList } from '@/api/common'

/**
 * @author 戴旭
 * @createDate 2023/02/28 15:28:11
 * @updateDate 2023/02/28 15:28:11
 * @description: 部门/岗位
 */

const deptQuarterRouter = [
  // 部门/岗位管理
  {
    path: '/jurisdictionSystem/department-manage',
    name: 'departmentManage',
    component: () =>
      import(
        /*webpackChunkName:"department" */
        // '@/views/jurisdictionSystem/department/Manage.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/dept-quarter/dept-quarter-manage/Page.vue'
      ),
    meta: {
      SecondaryMenu: '部门/岗位', //二级菜单
      title: '部门/岗位管理'
    },
    beforeEnter(to, from, next) {
      if (store.state.departmentList && store.state.departmentList.length > 0) {
        next()
      } else {
        getAllDp().then((res) => {
          if (0 === res.status) {
            let departmentList = res.data
            traverseDpTree(departmentList, 2)
            store.commit('setDepartmentList', departmentList)
            next()
          }
        })
      }
    }
  },

  // 历史组织架构
  {
    path: '/jurisdictionSystem/department-history',
    name: 'jurisdictionSystemHistoryRecord',
    component: () =>
      import(
        /*webpackChunkName:"jurisdictionSystemHistoryRecord" */
        // '@/views/jurisdictionSystem/department/HistoryRecord'
        '@/views/jurisdiction-manage/dept-juris-manage/dept-quarter/dept-quarter-manage/history/Page.vue'
      ),
    meta: {
      SecondaryMenu: '部门/岗位', //二级菜单
      title: '历史组织架构',
      breadcrumb: [
        {
          title: '部门/岗位管理',
          name: 'departmentManage'
        }
      ]
    }
  },

  // 历史组织架构详情
  {
    path: '/jurisdictionSystem/department-history-detail/:date',
    name: 'jurisdictionSystemHistoryRecordDetail',
    component: () =>
      import(
        /*webpackChunkName:"jurisdictionSystemHistoryRecord" */
        '@/views/jurisdictionSystem/department/HistoryRecordDetail'
      ),
    meta: {
      SecondaryMenu: '部门/岗位', //二级菜单
      title: '历史组织架构详情',
      breadcrumb: [
        {
          title: '部门/岗位管理',
          name: 'departmentManage'
        },
        {
          title: '历史组织架构',
          name: 'jurisdictionSystemHistoryRecord'
        }
      ]
    }
  },

  // 部门岗位管理/附属管理员/分组管理/添加分组
  // 部门岗位管理/添加部门
  {
    path: '/jurisdictionSystem/department-add/:parentId/:isShow/:meta_type',
    name: 'departmentAdd',
    component: () =>
      import(
        /*webpackChunkName:"department" */
        // '@/views/jurisdictionSystem/department/Edit.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/dept-quarter/dept-quarter-manage/subordinate-admin/group-manage/Add.vue'
      ),
    meta: {
      SecondaryMenu: '部门/岗位', //二级菜单
      isMoreMeta: true,
      1: {
        title: '添加分组',
        breadcrumb: [
          {
            title: '部门/岗位管理',
            name: 'departmentManage'
          },
          {
            title: '附属管理员',
            name: 'subordinateAdmin'
          },
          {
            title: '分组管理',
            name: 'subordinateAdminGroupManage'
          }
        ]
      },
      2: {
        title: '添加部门',
        breadcrumb: [
          {
            title: '部门/岗位管理',
            name: 'departmentManage'
          }
        ]
      }
    }
  },

  // 编辑部门
  {
    path: '/jurisdictionSystem/department-edit/:departmentId/:parentId/:isShow/:meta_type',
    name: 'departmentEdit',
    component: () =>
      import(
        /*webpackChunkName:"department" */
        '@/views/jurisdictionSystem/department/Edit.vue'
      ),
    meta: {
      SecondaryMenu: '部门/岗位', //二级菜单
      isMoreMeta: true,
      1: {
        title: '编辑分组',
        breadcrumb: [
          {
            title: '部门/岗位管理',
            name: 'departmentManage'
          },
          {
            title: '附属管理员',
            name: 'subordinateAdmin'
          },
          {
            title: '分组管理',
            name: 'subordinateAdminGroupManage'
          }
        ]
      },
      2: {
        title: '编辑部门',
        breadcrumb: [
          {
            title: '部门/岗位管理',
            name: 'departmentManage'
          }
        ]
      }
    }
  },

  // 附属管理员列表
  {
    path: '/jurisdictionSystem/subordinate-admin',
    name: 'subordinateAdmin',
    component: () =>
      import(
        /*webpackChunkName:"subordinateAdmin" */
        // '@/views/jurisdictionSystem/subordinateAdmin/List.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/dept-quarter/dept-quarter-manage/subordinate-admin/Page.vue'
      ),
    meta: {
      SecondaryMenu: '部门/岗位', //二级菜单
      title: '附属管理员',
      breadcrumb: [
        {
          title: '部门/岗位管理',
          name: 'departmentManage'
        }
      ]
    }
  },

  // 附属管理员 分组管理
  {
    path: '/jurisdictionSystem/subordinate-admin/group',
    name: 'subordinateAdminGroupManage',
    component: () =>
      import(
        /*webpackChunkName:"subordinateAdmin" */
        // '@/views/jurisdictionSystem/subordinateAdmin/GroupManage.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/dept-quarter/dept-quarter-manage/subordinate-admin/group-manage/Page.vue'
      ),
    meta: {
      SecondaryMenu: '部门/岗位', //二级菜单
      title: '分组管理',
      breadcrumb: [
        {
          title: '部门/岗位管理',
          name: 'departmentManage'
        },
        {
          title: '附属管理员',
          name: 'subordinateAdmin'
        }
      ]
    }
  },

  // 部门岗位管理/附属管理员/添加附属管理员
  // 部门岗位管理/添加岗位
  {
    path: '/jurisdictionSystem/quarter-add/:departmentId/:parentId/:isAttachedAdmin/:meta_type',
    name: 'quarterAdd',
    component: () =>
      import(
        /*webpackChunkName:"quarter" */
        '@/views/jurisdictionSystem/quarter/Add.vue'
      ),
    meta: {
      SecondaryMenu: '部门/岗位', //二级菜单
      isMoreMeta: true,
      1: {
        title: '添加岗位',
        breadcrumb: [
          {
            title: '部门/岗位管理',
            name: 'departmentManage'
          }
        ]
      },
      2: {
        title: '添加附属管理员',
        breadcrumb: [
          {
            title: '部门/岗位管理',
            name: 'departmentManage'
          },
          {
            title: '附属管理员',
            name: 'subordinateAdmin'
          }
        ]
      }
    }
  },

  // 编辑岗位
  {
    path: '/jurisdictionSystem/quarter-edit/:departmentId/:quarterId/:parentId/:isAttachedAdmin/:meta_type',
    name: 'quarterEdit',
    component: () =>
      import(
        /*webpackChunkName:"quarter" */
        // '@/views/jurisdictionSystem/quarter/Edit.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/dept-quarter/dept-quarter-manage/subordinate-admin/Edit.vue'
      ),
    beforeEnter(to, from, next) {
      const quarterId = to.params.quarterId
      getQuarterDetail(quarterId).then((res) => {
        if (0 === res.status) {
          const quarterDetail = res.data
          // quarterDetail.array_region_id
          let arrayRegionId = []
          for (let item of quarterDetail.array_region_id) {
            arrayRegionId.push(item + '')
          }
          quarterDetail.array_region_id = arrayRegionId
          // 获取所有省
          getRegionList('0', '1', '1').then((res) => {
            if (0 === res.status) {
              let regionList = res.data.regionList
              if (regionList.length === quarterDetail.array_region_id.length) {
                quarterDetail.array_region_id = ['0']
                quarterDetail.regionList = [
                  {
                    region_id: '0',
                    level: '-1',
                    region_name: '全国'
                  }
                ]
              }
              const item = {
                region_id: '0',
                region_name: '全国'
              }
              regionList.unshift(item)
              store.commit('setRegionList', regionList)
              store.commit('setQuarterDetail', quarterDetail)
              next()
            }
          })
        } else {
          // store.commit('setQuarterDetail', {});
          // next();
        }
      })
    },
    meta: {
      SecondaryMenu: '部门/岗位', //二级菜单
      isMoreMeta: true,
      1: {
        title: '编辑岗位',
        breadcrumb: [
          {
            title: '部门/岗位管理',
            name: 'departmentManage'
          }
        ]
      },
      2: {
        title: '编辑附属管理员',
        breadcrumb: [
          {
            title: '部门/岗位管理',
            name: 'departmentManage'
          },
          {
            title: '附属管理员',
            name: 'subordinateAdmin'
          }
        ]
      }
    }
  },

  // 部门迁移
  {
    path: '/jurisdictionSystem/department-transfer',
    name: 'departmentTransfer',
    component: () =>
      import(
        /*webpackChunkName:"department" */
        // '@/views/jurisdictionSystem/department/Transfer.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/dept-quarter/dept-quarter-manage/transfer/DeptTransfer.vue'
      ),
    meta: {
      SecondaryMenu: '部门/岗位', //二级菜单
      title: '部门迁移',
      breadcrumb: [
        {
          title: '部门/岗位管理',
          name: 'departmentManage'
        }
      ]
    }
  },

  // 岗位迁移
  {
    path: '/jurisdictionSystem/quarter-transfer',
    name: 'quarterTransfer',
    component: () =>
      import(
        /*webpackChunkName:"quarter" */
        // '@/views/jurisdictionSystem/quarter/Transfer.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/dept-quarter/dept-quarter-manage/transfer/QuarterTransfer.vue'
      ),
    meta: {
      SecondaryMenu: '部门/岗位', //二级菜单
      title: '岗位迁移',
      breadcrumb: [
        {
          title: '部门/岗位管理',
          name: 'departmentManage'
        }
      ]
    }
  },

  // 批量添加部门
  {
    path: '/jurisdictionSystem/department-batch-add',
    name: 'departmentBatchAdd',
    component: () =>
      import(
        /*webpackChunkName:"department" */
        // '@/views/jurisdictionSystem/department/BatchAdd.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/dept-quarter/dept-quarter-manage/batch-operation/AddDepartment.vue'
      ),
    meta: {
      SecondaryMenu: '部门/岗位', //二级菜单
      title: '批量添加部门',
      breadcrumb: [
        {
          title: '部门/岗位管理',
          name: 'departmentManage'
        }
      ]
    }
  },

  // 批量更新部门标签
  {
    path: '/jurisdictionSystem/batch-department-labels',
    name: 'departmentBatchUpdateLabels',
    component: () =>
      import(
        /*webpackChunkName:"department" */
        // '@/views/jurisdictionSystem/department/BatchUpdateLabels.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/dept-quarter/dept-quarter-manage/batch-operation/UpdateDepartmentLabels.vue'
      ),
    meta: {
      SecondaryMenu: '部门/岗位', //二级菜单
      title: '批量更新部门标签',
      breadcrumb: [
        {
          title: '部门/岗位管理',
          name: 'departmentManage'
        }
      ]
    }
  },

  // 批量添加/更新岗位
  {
    path: '/jurisdictionSystem/quarter-batch-add',
    name: 'quarterBatchAdd',
    component: () =>
      import(
        /*webpackChunkName:"department" */
        // '@/views/jurisdictionSystem/quarter/BatchAdd.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/dept-quarter/dept-quarter-manage/batch-operation/EditQuarter.vue'
      ),
    meta: {
      SecondaryMenu: '部门/岗位', //二级菜单
      title: '批量添加/更新岗位',
      breadcrumb: [
        {
          title: '部门/岗位管理',
          name: 'departmentManage'
        }
      ]
    }
  },

  // 批量更新产品
  {
    path: '/jurisdictionSystem/batch-update-goods',
    name: 'batchUpdateGoods',
    component: () =>
      import(
        /*webpackChunkName:"department" */
        // '@/views/jurisdictionSystem/department/BatchUpdateGoods.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/dept-quarter/dept-quarter-manage/batch-operation/UpdateGoods.vue'
      ),
    meta: {
      SecondaryMenu: '部门/岗位', //二级菜单
      title: '批量更新产品',
      breadcrumb: [
        {
          title: '部门/岗位管理',
          name: 'departmentManage'
        }
      ]
    }
  },

  // 批量停用/删除岗位
  {
    path: '/jurisdictionSystem/batch-edit-quarter',
    name: 'batchEditQuarter',
    component: () =>
      import(
        /*webpackChunkName:"department" */
        // '@/views/jurisdictionSystem/department/BatchEditQuarter.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/dept-quarter/dept-quarter-manage/batch-operation/DisableDelQuarter.vue'
      ),
    meta: {
      SecondaryMenu: '部门/岗位', //二级菜单
      title: '批量停用/删除岗位',
      breadcrumb: [
        {
          title: '部门/岗位管理',
          name: 'departmentManage'
        }
      ]
    }
  }
]

export default deptQuarterRouter
